/**
 * EventManagementPage - Gerenciamento de Eventos
 * 
 * Página para operações de limpeza e manutenção
 */

import { type FC, useState } from 'react';
import StandardPage from '@/components/Common/StandardPage';
import Button from '@/components/Common/Button';
import { eventService } from '@/services';
import styles from './EventsPage.module.css';

export const EventManagementPage: FC = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  const handleCleanupProcessed = async () => {
    if (!confirm('Deseja limpar eventos processados com mais de 30 dias?')) {
      return;
    }

    try {
      setIsProcessing(true);
      setMessage(null);
      
      const result = await eventService.cleanupEvents({
        olderThanDays: 30,
        onlyProcessed: true,
      });

      setMessage(`✅ ${result.affectedRecords} eventos foram removidos com sucesso!`);
    } catch (err) {
      setMessage('❌ Erro ao limpar eventos');
      console.error(err);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleReprocessOld = async () => {
    if (!confirm('Deseja reprocessar eventos pendentes com mais de 24 horas?')) {
      return;
    }

    try {
      setIsProcessing(true);
      setMessage(null);
      
      const result = await eventService.reprocessEvents({
        olderThanHours: 24,
      });

      setMessage(`✅ ${result.affectedRecords} eventos foram reprocessados!`);
    } catch (err) {
      setMessage('❌ Erro ao reprocessar eventos');
      console.error(err);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <StandardPage
      header={{
        title: "Gerenciamento de Eventos",
        subtitle: "Operações de limpeza e manutenção do sistema",
      }}
    >
      <div className={styles.managementContainer}>
        {message && (
          <div className={styles.messageBox}>
            {message}
          </div>
        )}

        <div className={styles.managementGrid}>
          {/* Cleanup Section */}
          <div className={styles.managementCard}>
            <h3>Limpeza de Eventos</h3>
            <p>Remove eventos processados antigos para liberar espaço</p>
            <Button
              variant="secondary"
              onClick={handleCleanupProcessed}
              disabled={isProcessing}
            >
              Limpar Eventos Processados (30+ dias)
            </Button>
          </div>

          {/* Reprocess Section */}
          <div className={styles.managementCard}>
            <h3>Reprocessamento</h3>
            <p>Reprocessa eventos pendentes que estão travados</p>
            <Button
              variant="primary"
              onClick={handleReprocessOld}
              disabled={isProcessing}
            >
              Reprocessar Eventos Antigos (24+ horas)
            </Button>
          </div>
        </div>
      </div>
    </StandardPage>
  );
};

export default EventManagementPage;
